import React from 'react';
import { motion } from 'framer-motion';
import { Trash2, Scissors, Zap, Wind, Building2 } from 'lucide-react';
import { Card, CardContent } from './Card';
export function Services() {
  const services = [{
    icon: Trash2,
    title: 'Tree Removal',
    description: 'Safe, complete removal of dead, dying, or hazardous trees'
  }, {
    icon: Scissors,
    title: 'Tree Trimming & Pruning',
    description: 'Reduce weight, improve shape, protect your home'
  }, {
    icon: Zap,
    title: 'Emergency Tree Services',
    description: 'Storm damage? We respond fast.'
  }, {
    icon: Wind,
    title: 'Storm Cleanup',
    description: 'Full cleanup and haul-away after high winds'
  }, {
    icon: Building2,
    title: 'Residential & Commercial Tree Care',
    description: 'Homes, HOAs, and commercial properties'
  }];
  return <section id="services" className="w-full bg-brand-bg py-16 md:py-24" data-id="element-87">
      <div className="container mx-auto px-6" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-3xl md:text-5xl text-white text-center mb-12 md:mb-16" data-id="element-89">
          What We Do
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-90">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          boxShadow: '0 0 30px rgba(94, 182, 43, 0.3)'
        }} data-id="element-91">
              <Card className="bg-zinc-900 border-t-4 border-t-brand-green border-zinc-800 h-full transition-all duration-300" data-id="element-92">
                <CardContent className="p-6" data-id="element-93">
                  <service.icon className="w-12 h-12 text-brand-green mb-4" data-id="element-94" />
                  <h3 className="font-heading-alt text-xl text-white font-bold mb-2" data-id="element-95">
                    {service.title}
                  </h3>
                  <p className="font-body text-white/70 text-sm leading-relaxed" data-id="element-96">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-97">
          <a href="#contact" className="font-body text-brand-green hover:text-brand-green/80 underline text-lg transition-colors" data-id="element-98">
            Need Something Else? Call Us
          </a>
        </div>
      </div>
    </section>;
}